<template>
  <div class="contact-form-section section-space--ptb_120" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 order-2 order-lg-1">
          <div class="section-title text-left section-space--mb_60 wow move-up">
            <h2 class="font-weight--bold mb-15 wow move-up">Hire Us</h2>
            <span class="section-text_left wow move-up"
              >Do you want HobbsTech to help you digitize your business world.
              Please let us know how we can help you by filling the form below.
              We will get intouch with you as soon as possible.
            </span>
          </div>
          <div class="contact-from-wrapper wow move-up">
            <form
              id="contact-form"
              action="#"
              method="post"
              @submit.prevent="sendMessage"
            >
              <div class="contact-page-form">
                <div class="contact-inner">
                  <label for="name"> Your Name or Company Name </label>
                  <input
                    id="name"
                    v-model="name"
                    required
                    type="text"
                    placeholder="Name *"
                    maxlength="100"
                  />
                </div>
                <div class="contact-inner">
                  <label for="email"> Your Email </label>
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    placeholder="Email *"
                    required
                    maxlength="100"
                  />
                </div>
                <div class="contact-inner">
                  <label for="email"> Your Contact Number (optional) </label>
                  <input
                    id="contactNumber"
                    v-model="contactNumber"
                    type="text"
                    placeholder="Contact Number"
                    maxlength="16"
                  />
                </div>
                <div class="contact-inner">
                  <label for="subject">Subject of Job to be done </label>
                  <input
                    id="subject"
                    v-model="subject"
                    type="text"
                    placeholder="Subject *"
                    required
                    maxlength="255"
                  />
                </div>
                <div class="contact-inner">
                  <label for="startDate"
                    >Choose your expected start date (optional)
                  </label>
                  <input id="startDate" v-model="startDate" type="date" />
                </div>
                <div class="contact-inner">
                  <label for="description">
                    Describe the type of system you want us to build for you, or
                    the job you want to hire us for.
                  </label>
                  <textarea
                    id="description"
                    name="message"
                    v-model="description"
                    placeholder="Job description *"
                    required
                  ></textarea>
                </div>
                <HAlert
                  v-if="showAlert && dismissSecs"
                  :dismiss-secs="dismissSecs"
                  :message="alertMessage"
                  :variant="alertType"
                />
                <div class="contact-submit-btn text-center">
                  <b-button
                    v-show="!loading"
                    class="ht-btn ht-btn-md"
                    type="submit"
                  >
                    Submit
                  </b-button>
                  <b-spinner
                    v-show="loading"
                    variant="primary"
                    label="Spinning"
                  ></b-spinner>
                  <p class="form-messege"></p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-5 order-1 order-lg-2">
          <div class="peatures_image-wrap section-space--mb_40">
            <div class="image text-center wow move-up">
              <img
                class="img-fluid"
                src="../assets/img/features/contact-form-image-01.png"
                alt="contact thumb"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HAlert from "@/components/HAlert";
import { postJson } from "@/utils/HttpClient";

export default {
  name: "HireUsForm",
  components: { HAlert },
  data() {
    let loading = false;
    let showAlert = false;

    return {
      loading,
      showAlert,
      name: "",
      email: "",
      subject: "",
      description: "",
      startDate: "",
      contactNumber: "",
      dismissSecs: 0,
      alertMessage: "",
      alertType: "success",
    };
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  methods: {
    sendMessage() {
      this.setLoading(true);
      this.dismissSecs = 5;
      postJson({
        url: `${this.baseUrl}/v1/hire-us`,
        data: {
          name: this.name,
          email: this.email,
          subject: this.subject,
          description: this.description,
          startDate: this.startDate,
          contactNumber: this.contactNumber,
        },
      })
        .then(() => {
          this.dismissSecs = 5;
          this.showAlert = true;
          this.alertMessage = "Message sent successfully";
        })
        .catch((err) => {
          if (err.response.status >= 500) {
            this.alertMessage =
              "Sorry, failed to send your message, please try again later";
          } else if (err.response.status >= 400 && err.response.status < 500) {
            this.alertMessage = err.response.data.message;
          }
          this.dismissSecs = 5;
          this.showAlert = true;
          this.alertType = "danger";
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    setLoading(value) {
      this.loading = value;
    },
  },
};
</script>
